import { Box, Card, Stack, Stepper, Text } from '@mantine/core'
import { useNavigate } from 'react-router-dom'
import { useEffect } from 'react'
import { useAuthStore } from '@/store/auth'
import { BrandLogo } from '@/components/ui/BrandLogo'
import { SetupWizardStepPassword } from './SetupWizardStepPassword'
import { SetupWizardStepPersonalData } from './SetupWizardStepPersonalData'
import { SetupWizardStepTotp } from './SetupWizardStepTotp'

export function SetupWizard() {
  const navigate = useNavigate()
  const { user, mustChangePassword, refreshUser } = useAuthStore()

  // Determina qual step mostrar — derivado de user/mustChangePassword
  const needsPassword = mustChangePassword
  const needsPersonalData = !mustChangePassword
    && (user?.missing_required_fields?.length ?? 0) > 0
  const needsTotp = !mustChangePassword
    && (user?.missing_required_fields?.length ?? 0) === 0
    && !user?.has_totp
  const allDone = !needsPassword && !needsPersonalData && !needsTotp

  useEffect(() => {
    if (allDone) navigate('/', { replace: true })
  }, [allDone, navigate])

  const advance = async () => {
    await refreshUser()
    // Re-render decide o proximo step automaticamente
  }

  if (!user) return null

  let stepContent: React.ReactNode = null
  let stepIndex = 0
  if (needsPassword) {
    stepContent = <SetupWizardStepPassword onComplete={advance} />
    stepIndex = 0
  } else if (needsPersonalData) {
    stepContent = (
      <SetupWizardStepPersonalData
        missingFields={user.missing_required_fields ?? []}
        onComplete={advance}
      />
    )
    stepIndex = 1
  } else if (needsTotp) {
    stepContent = <SetupWizardStepTotp onComplete={advance} />
    stepIndex = 2
  }

  return (
    <Box
      style={{
        minHeight: '100vh',
        background: 'var(--ai-auth-bg)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '24px',
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      <Box
        style={{
          position: 'absolute',
          top: '-30%',
          left: '50%',
          transform: 'translateX(-50%)',
          width: '600px',
          height: '600px',
          background: 'radial-gradient(circle, rgba(9, 141, 147, 0.08) 0%, transparent 70%)',
          pointerEvents: 'none',
        }}
      />

      <Box style={{ width: '100%', maxWidth: 540, position: 'relative', zIndex: 1 }}>
        <Stack align="center" mb="xl" gap={4}>
          <BrandLogo variant="horizontal" color="white" width={180} />
          <Text size="xs" c="rgba(255,255,255,0.35)" mt={8} fw={600} tt="uppercase" style={{ letterSpacing: '0.08em' }}>
            Configuração Inicial
          </Text>
        </Stack>

        <Card
          radius="md"
          p="xl"
          style={{
            backgroundColor: 'var(--ai-auth-card-bg)',
            border: '1px solid var(--ai-auth-border)',
            boxShadow: '0 16px 48px rgba(0, 0, 0, 0.3)',
          }}
        >
          <Stack gap="md">
            <Stepper
              active={stepIndex} size="xs" iconSize={20} color="teal"
              styles={{
                stepLabel: { color: '#b6c2c9', fontSize: 11 },
                separator: { backgroundColor: 'var(--ai-auth-border)' },
              }}
            >
              <Stepper.Step label="Senha" />
              <Stepper.Step label="Dados pessoais" />
              <Stepper.Step label="2FA" />
            </Stepper>
            {stepContent}
          </Stack>
        </Card>

        <Text size="xs" c="rgba(255,255,255,0.2)" ta="center" mt="md" fw={500}>
          &copy; 2025-2026 Amazonas Inovare. All rights reserved.
        </Text>
      </Box>
    </Box>
  )
}
